export default {
  isMobile(state) {
    return state.mobile;
  },
};
